import { Components, Theme } from "@mui/material";

export const MuiDivider: Components<Theme>["MuiDivider"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      background: theme.newColors.neutral.gray200,
    }),
  },
};
